import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  items: [],
  totalItems: 0,
  totalAmount: 0,
}

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const { id, name, price, size, images } = action.payload
      const existingItem = state.items.find((item) => item.id === id && item.size === size)

      if (existingItem) {
        existingItem.quantity += 1
      } else {
        state.items.push({
          id,
          name,
          price,
          size,
          images,
          quantity: 1,
        })
      }

      state.totalItems = state.items.reduce((total, item) => total + item.quantity, 0)
      state.totalAmount = state.items.reduce((total, item) => total + item.price * item.quantity, 0)
    },

    removeFromCart: (state, action) => {
      const { id, size } = action.payload
      state.items = state.items.filter((item) => !(item.id === id && item.size === size))

      state.totalItems = state.items.reduce((total, item) => total + item.quantity, 0)
      state.totalAmount = state.items.reduce((total, item) => total + item.price * item.quantity, 0)
    },

    updateQuantity: (state, action) => {
      const { id, quantity, size } = action.payload
      const item = state.items.find((item) => item.id === id && (size ? item.size === size : true))

      if (item) {
        if (quantity <= 0) {
          state.items = state.items.filter((cartItem) => cartItem !== item)
        } else {
          item.quantity = quantity
        }
      }

      state.totalItems = state.items.reduce((total, item) => total + item.quantity, 0)
      state.totalAmount = state.items.reduce((total, item) => total + item.price * item.quantity, 0)
    },

    clearCart: (state) => {
      state.items = []
      state.totalItems = 0
      state.totalAmount = 0
    },
  },
})

export const { addToCart, removeFromCart, updateQuantity, clearCart } = cartSlice.actions
export default cartSlice.reducer
